import React, { useEffect, useState } from "react";
import { Grid, TextField } from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import ReactQuill from "react-quill";
import { isMobile } from "../../globalStyles/mobile";
import "react-quill/dist/quill.snow.css";
import ClientAutocomplete from "../clientAutocomplete";
import AutocompleteWithPagination from "../autocomplete-with-pagination";
import { categoryService } from "../../utils/services/categoryService";
import buildQuery from "../../utils/query-builder";

const BasicProductDetails = ({
  productDetails,
  setProductDetails,
  clientId,
  setSelectedClient,
  selectedClient,
  formErrors,
  setFormErrors,
}) => {
  const [localDetails, setLocalDetails] = useState(productDetails);
  const [localClient, setLocalClient] = useState({ name: "" });

  useEffect(() => {
    // Only update selectedClient when localClient actually changes
    if (localClient?._id !== selectedClient?._id) {
      setSelectedClient(localClient);
    }
  }, [localClient]);

  useEffect(() => {
    // Set localClient only if different (prevents recursion)
    if (selectedClient?._id && selectedClient?._id !== localClient?._id) {
      setLocalClient(selectedClient);
    }
  }, [selectedClient]);

  useEffect(() => {
    setProductDetails(localDetails);
  }, [localDetails]);

  useEffect(() => {
    setLocalDetails(productDetails);
  }, [productDetails]);

  // useEffect(() => {
  //   if (selectedClient?._id) {
  //     setLocalClient(selectedClient);
  //   }
  // }, [selectedClient]);

  return (
    <>
      {!clientId && (
        <Grid item xs={6} sm={12} md={12} sx={12}>
          <CustomTypography
            style={{ textAlign: "left", fontWeight: 500 }}
            fontSize={15}
          >
            Select Client <span style={{ color: "red" }}>*</span>
          </CustomTypography>
          <ClientAutocomplete
            hideLabel
            key={selectedClient?._id || "new"}
            selectedClient={localClient}
            onClientChange={(e) => {
              setLocalClient(e);
              setFormErrors({ ...formErrors, client_id: "" });
            }}
            width="100%"
            backgroundColor="var(--bg-paper)"
            errorMessage={formErrors.client_id ? formErrors.client_id : ""}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          Name <span style={{ color: "red" }}>*</span>
        </CustomTypography>
        <TextField
          sx={{ marginTop: 1, backgroundColor: "var(--bg-paper)" }}
          size="small"
          placeholder={`Enter Product Name`}
          variant="outlined"
          value={localDetails.name}
          onChange={(e) => {
            setLocalDetails({ ...localDetails, name: e.target.value });
            setFormErrors({ ...formErrors, name: "" });
          }}
          fullWidth
          error={!!formErrors.name}
          helperText={formErrors.name ? formErrors.name : ""}
        />
      </Grid>

      <Grid item xs={6} sm={6}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          Category <span style={{ color: "red" }}>*</span>
        </CustomTypography>
        <AutocompleteWithPagination
          key={selectedClient?._id || "no-client"}
          disabled={!localStorage.getItem("client_id") && !selectedClient?._id}
          backgroundColor="var(--bg-paper)"
          // customLabel="Category"
          hideLabel
          placeholder="Select Category"
          selectedItem={localDetails.category_id}
          selectedClient={selectedClient}
          onDataChange={(category) => {
            setLocalDetails((prev) => ({
              ...prev,
              category_id: category || null,
            }));
            setFormErrors({ ...formErrors, category_id: undefined });
          }}
          width="100%"
          optionKey="name"
          apiEndPoint={(limit, skip, search, client) => {
            const query = buildQuery({ limit: limit, skip: skip });
            return categoryService.fetch(search, client, ["name"], query);
          }}
          errorMessage={formErrors.category_id ? formErrors.category_id : ""}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          Product Type
        </CustomTypography>
        <TextField
          sx={{ backgroundColor: "var(--bg-paper)" }}
          value={localDetails.product_type}
          size="small"
          margin="dense"
          placeholder="Enter Type"
          type="text"
          fullWidth
          onChange={(e) =>
            setLocalDetails({ ...localDetails, product_type: e.target.value })
          }
          error={!!formErrors.product_type}
          helperText={formErrors.product_type ? formErrors.product_type : ""}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          Short Description
        </CustomTypography>
        <TextField
          sx={{ marginTop: 1, backgroundColor: "var(--bg-paper)" }}
          size="small"
          placeholder={`Enter Short Description`}
          variant="outlined"
          value={localDetails.short_description}
          onChange={(e) =>
            setLocalDetails({
              ...localDetails,
              short_description: e.target.value,
            })
          }
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          PGA Flag
        </CustomTypography>
        <TextField
          sx={{ marginTop: 1, backgroundColor: "var(--bg-paper)" }}
          size="small"
          placeholder={`Enter PGA Flag`}
          variant="outlined"
          value={localDetails.pga_flag}
          onChange={(e) =>
            setLocalDetails({ ...localDetails, pga_flag: e.target.value })
          }
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          URL
        </CustomTypography>
        <TextField
          sx={{ marginTop: 1, backgroundColor: "var(--bg-paper)" }}
          size="small"
          placeholder={`Enter Product URL`}
          type="url"
          variant="outlined"
          value={localDetails.url}
          onChange={(e) =>
            setLocalDetails({ ...localDetails, url: e.target.value })
          }
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <CustomTypography
          style={{ textAlign: "left", fontWeight: 500 }}
          fontSize={15}
        >
          Description
        </CustomTypography>
        <div style={{ marginBottom: "30px" }}>
          <ReactQuill
            theme="snow"
            value={localDetails.description}
            onChange={(e) =>
              setLocalDetails({ ...localDetails, description: e })
            }
            placeholder="Enter product description"
            style={{
              marginTop: 5,
              backgroundColor: "var(--bg-paper)",
              height: isMobile() ? "70px" : "120px",
            }}
          />
          <style>{`
            .ql-container {
              background-color: #FFFFFF !important;
              height: 100%;
            }
            .ql-editor {
              min-height: 100%;
              background-color: #FFFFFF !important;
              padding: 10px;
              border-radius: 8px;
            }
            .ql-tooltip {
              position: absolute !important;
              top: 50% !important;
              left: 50% !important;
              transform: translate(-50%, -50%) !important;
              max-width: 90vw;
              width: auto;
              z-index: 1000;
            }
            .ql-tooltip a {
              cursor: pointer;
              text-decoration: underline;
            }
          `}</style>
        </div>
      </Grid>
    </>
  );
};

export default BasicProductDetails;
